export default __webpack_public_path__ + "static/media/Slide30.acea0ca8.JPG";